import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";

export const postChatbotApi = createAsyncThunk(
  "chatbot/postChatbotApi",
  async ({ updateObj, signal }: { updateObj: any; signal: AbortSignal }) => {
    try {
      const response = await axiosInstance.post(
        Api.postChatbotMessage,
        updateObj,
        { signal }
      );
      return response.data;
    } catch (error: unknown) {
      // Check if the error is an AxiosError and if it's a cancellation
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
        return; // Handle the cancel scenario (e.g., return a specific state or message)
      }

      // If it's an Axios error but not a cancellation, rethrow or handle it
      if (error instanceof AxiosError) {
        console.error("Axios error occurred:", error.message);
        throw error.response?.data || error.message;
      }

      // Handle any other type of errors
      throw new Error("An unexpected error occurred");
    }
  }
);
